<template>
  <div>
    <v-row justify="center" class="ma-0">
      <v-col cols="12" class="pa-0">
        <v-toolbar height="60" dark color="grey">
          <v-btn fab x-small color="white" depressed @click="onClose()">
            <v-icon class="grey--text">close</v-icon>
          </v-btn>
          <v-toolbar-title class="white--text pl-2">設定</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="elevation-0" small rounded @click="onSave()">保存</v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-card tile elevation="0" class='overflow-y-auto' :style="contentsHeight">
    <v-list
      subheader
      flat
    >
      <v-list-item-group
        multiple
      >
        <v-list-item v-for="(item, index) in schools" :ripple="false" :key="index">
            <v-list-item-action>
              <v-checkbox
                v-model="settings[item.key]"
                color="primary"
              ></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="caption">{{ item.name }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    </v-card>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'

export default {
  props: ['schools'],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: white; height: ' + String(this.windowSize.y - 60) + 'px;'
    }
  },
  data () {
    return {
      loading: false,
      settings: {}
    }
  },
  created () {
    for (var i in this.schools) {
      Vue.set(this.settings, this.schools[i].key, false)
    }
    if (typeof this.data.diagnose !== 'undefined') {
      var keys = Object.keys(this.data.diagnose)
      for (var x in keys) {
        this.settings[keys[x]] = this.data.diagnose[keys[x]]
      }
    } else {
      keys = Object.keys(this.settings)
      for (x in keys) {
        this.settings[keys[x]] = true
      }
    }
  },
  mounted () {
  },
  methods: {
    onSave () {
      var vm = this
      this.loading = true
      const db = firebase.firestore()
      var ref = db.collection('users').doc(this.user.uid)
      ref.update({
        diagnose: JSON.parse(JSON.stringify(this.settings)),
        updatedAt: parseInt(new Date().getTime())
      }).then(function () {
        vm.loading = false
      })
    },
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>

<style>
</style>
